import { Platform, StyleSheet } from "react-native";
import { Colors, useTheme } from "react-native-paper";

export const MainLayoutStyles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
